<svg-icon-sprite
  [classes]="type === 'error' ? 'error-color' : 'primary-color'"
  [src]="'assets/sprites/sprite.svg#warning-sign'"
  [width]="'32px'"
></svg-icon-sprite>

<div class="content">
  <ng-content></ng-content>
</div>
